// extracted by mini-css-extract-plugin
module.exports = {"ksModal":"Ks23Modal_ksModal__fAkYW","ksContent":"Ks23Modal_ksContent__1m6kj","table":"Ks23Modal_table__3Ggoy","actionBlock":"Ks23Modal_actionBlock__3rTh-"};